import { AgviewsConnectService } from 'src/app/service/agviews-connect.service';
import { MatDialog } from '@angular/material/dialog';
import { VerificarPermissoes } from './../model/verificarPermissoes.model';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout'
import { MatSidenav } from '@angular/material/sidenav';
import { DialogAcessosPremocenterComponent } from '../relatorios/dialog-acessos-premocenter/dialog-acessos-premocenter.component';


@Component({
  selector: 'app-configuracao',
  templateUrl: './configuracao.component.html',
  styleUrls: ['./configuracao.component.css']
})
export class ConfiguracaoComponent implements OnInit
{

  @ViewChild(MatSidenav)
  sidenav!: MatSidenav

  usuario = this.obterUsuario();
  exibirBadge: boolean = false;
  qtdAgviewsConnectSemClienteEProduto: number = 0;

  constructor(
    private observer: BreakpointObserver,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private agviewsConnectService: AgviewsConnectService
  ) { }

  ngAfterViewInit(): void
  {
    this.observer.observe(['(max-width: 800px)']).subscribe((resp) =>
    {
      if (resp.matches) {
        this.sidenav.mode = 'over';
        this.sidenav.close();
      } else {
        this.sidenav.mode = 'side';
        this.sidenav.open();
      }
      this.cdr.detectChanges()
    })
  }

  ngOnInit(): void
  {
    this.verificarQntAgviewsConnectSemClienteProduto();
  }

  obterUsuario()
  {
    const usuario = window.localStorage.getItem('usuario');
    return usuario;
  }

  public verificarPermissao(permissoesFuncionalidades: string[]): boolean
  {
    const permissaoUsuario = localStorage.getItem('permissoes');
    return VerificarPermissoes.temPermissao(permissoesFuncionalidades, permissaoUsuario)
  }

  exibirModalRelatorio(): void
  {
    this.dialog.open(DialogAcessosPremocenterComponent, {
      panelClass: 'relatorio-dialog',
      width: '520px'
    });
  }

  verificarQntAgviewsConnectSemClienteProduto(): void
  {
    this.agviewsConnectService.quantidadeAgviewsConnectSemClienteEProduto().subscribe((response: any) => {
      this.exibirBadge = response > 0;
      this.qtdAgviewsConnectSemClienteEProduto = response;
    });
  }
}
